/*
|--------------------------------------------------------------------------
| Views: Slider Basic
|--------------------------------------------------------------------------
*/

/**
 * Slider Basic View
 * @namespace
 */
__gh__webApp.views.sliderWidget = {

	"callbacks": function(bucket){
		__gh__webApp.utilities.slider.loadAllSliders();
	},


	"getSubView": function(bucket){
		var sliderSettings	= this.getSliderSettings(bucket.id);
		//Update bucket
		bucket.view.name 					= "buckets/sliderWidget/default";
		bucket.view.sliderSettings 			= sliderSettings;
		return bucket;
	},


	"getSliderSettings":function(bucketID){
		var sliderSettings = {
			"infinite":true,
			"speed":300,
			"slidesToShow":1,
			"slidesToScroll":1,
			"lazyLoad":"ondemand",
			"arrows":true,
			"autoplay":false,
			"autoplaySpeed":2000
		}
		
		return sliderSettings;
	}

};
